import {
  Body,
  Box,
  FieldHeader,
  InlineMessage,
  LocalizedString,
  NonNegativeInteger,
  ReadOnlyTextFieldG4P,
  Space,
  TextChildren,
  useComponentsWrapperContext,
  useUniqueID,
} from "@dbn/omnichannel-design-system-g4p";
import { ComponentProps } from "react";

export type ReadOnlyTextFieldProps = {
  label: LocalizedString | TextChildren;
  labelWeight?: "medium" | "regular" | "bold";
  labelSize?:
    | "xx-small"
    | "x-small"
    | "small"
    | "medium"
    | "large"
    | "big"
    | "x-large";
  value: LocalizedString;
  inverted?: boolean;
  size: "small" | "x-small" | "input" | "large" | "big";
  fractionDigits?: NonNegativeInteger;
  description?: LocalizedString;
  feedback?: {
    type: ComponentProps<typeof InlineMessage>["type"];
    message: LocalizedString;
  };
};

export function InnerReadOnlyTextField(props: ReadOnlyTextFieldProps) {
  const labelId = useUniqueID();
  return (
    <Box column shrink>
      <FieldHeader
        labelId={labelId}
        label={props.label}
        inverted={props.inverted}
        readonly
        description={props.description}
      />
      <Body size={"x-small"} weight={"regular"}>
        {props.value}
      </Body>
      {props.feedback && (
        <Box column>
          <Space units={1} />
          <InlineMessage
            size="medium"
            type={props.feedback.type}
            message={props.feedback.message}
          />
        </Box>
      )}
    </Box>
  );
}

export function ReadOnlyTextField(props: ReadOnlyTextFieldProps) {
  const { componentType } = useComponentsWrapperContext();
  return (
    <>
      {componentType === "notG4p" && (
        <InnerReadOnlyTextField {...(props as ReadOnlyTextFieldProps)} />
      )}
      {(!componentType || componentType === "g4p") && (
        <ReadOnlyTextFieldG4P {...(props as ReadOnlyTextFieldProps)} />
      )}
    </>
  );
}
